import { EqlFieldName } from '@modules/common/constants';
import { isEmptyWhereClause } from '@modules/common/utils';
import {
  useGetQuantifyCompareQuery,
  useGetQuantifyWhereClause,
} from '@modules/quantify/hooks';
import { FieldNames } from 'v2/core/entities/fields';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import useQueryInspector from 'v2/core/services/queryBuilder/useQueryInspector';
import {
  EmptyWhereClause,
  OperationType,
} from 'v2/core/services/queryBuilder/whereClause';
import { useQuantifyStore } from '../store/quantifyStore';

export const useShouldShowQuantifyCooccurringToggle = () => {
  const groupBy = useQuantifyStore(({ query }) => query.groupByField);
  const compareQuery = useGetQuantifyCompareQuery();

  const whereClause = useGetQuantifyWhereClause();

  const whereClauseToUse = compareQuery?.whereClause
    ? combineWhereClauses(
        whereClause,
        compareQuery.whereClause ?? EmptyWhereClause,
        OperationType.AND,
      )
    : whereClause;

  const entityFilters = useQueryInspector(whereClauseToUse, FieldNames.Entity);
  const reasonFilters = useQueryInspector(whereClauseToUse, FieldNames.Reason);

  if (
    groupBy?.field !== EqlFieldName.Entity &&
    groupBy?.field !== EqlFieldName.Reason
  ) {
    return false;
  }

  if (
    !whereClauseToUse ||
    isEmptyWhereClause(whereClauseToUse) ||
    (entityFilters.length === 0 && reasonFilters.length === 0)
  ) {
    return false;
  }

  return true;
};
